export default (photoPackage, packages) => ({
    photoPackage,
    packages,
    options: [],

    init() {
        this.setOptions();

        window.addEventListener('main-event-updated', () => {
            this.options = []
        });
    },

    setOptions() {
        packages.filter(
            (item) => item && (item.name || Object.keys(item).length !== 0))
                .forEach((item) => {
                    this.options.push({
                        preview: item.preview,
                        price: formatCurrency(item.price),
                        value: item.name,
                        description: item.description,
                        id: item.id,
                    });
                });

        if (this.options.length == 1) {
            this.photoPackage = this.options[0].id;
        }
    },
});
